import React from 'react';
import { Link } from 'react-router-dom';
import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  SelectInput,
  ReferenceInput,
  BooleanInput,
  FunctionField,
  Filter,
  translate as t,
} from 'admin-on-rest';
import { FlatButton } from 'material-ui';
import FormInput from 'admin-on-rest/lib/mui/form/FormInput';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import TranslatableInput from '../components/inputs/TranslatableInput';
import TranslatableField from '../components/fields/TranslatableField';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import ImageInput from '../components/inputs/ImageInput';
import ThumbnailImageField from '../components/fields/ThumbnailImageField';

const WebsitePagesFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="website" source="website" reference="web-sites" allowEmpty alwaysOn>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const WebsitePagesList = t((props) => (
  <List {...props} perPage={9999} filters={<WebsitePagesFilter />}>
    <Datagrid>
      <TextField source="slug" />
      <TranslatableField source="metaContent.title" />
      <TextField source="website.name" />
      <FunctionField
        render={(record) =>
          record.frozen ? (
            <FlatButton disabled>Builder</FlatButton>
          ) : (
            <FlatButton primary containerElement={Link} to={`/page-builder/${record.id}`}>
              Builder
            </FlatButton>
          )
        }
      />
      <EditButton {...props} />
      <DeleteButton {...props} />
    </Datagrid>
  </List>
));

const selector = getFormValues('record-form');
const ConditionalSection = connect((state) => ({ record: selector(state) }))(
  ({ record, children, ...props }) => {
    if (record.frozen) {
      return null;
    }
    return React.Children.map(children, (input) =>
      input ? <FormInput {...props} input={input} /> : null,
    );
  },
);

const Form = (props) => (
  <SimpleForm {...props}>
    <BooleanInput source="published" />
    <BooleanInput source="frozen" />
    <ConditionalSection>
      <TextInput source="slug" />
      <ReferenceInput
        {...props}
        format={(value) => value && value._id}
        label={props.translate('resources.web-sites.name', { smart_count: 1 })}
        source="website"
        reference="web-sites"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <ImageInput source="heroImage" accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <TranslatableInput {...props} source="bannerTitle" />
      <TranslatableInput {...props} source="headingBold" />
      <TranslatableInput {...props} source="headingThin" />
      <TextInput {...props} source="video" />
      <ImageInput source="videoPoster" accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <ImageInput source="backupImage" accept="image/*">
        <ThumbnailImageField source="src" />
      </ImageInput>
      <TranslatableInput {...props} source="metaContent.title" />
      <TranslatableInput {...props} source="metaContent.ogTitle" />
      <TranslatableInput {...props} source="metaContent.description" />
    </ConditionalSection>
  </SimpleForm>
);

export const WebsitePagesEdit = t((props) => (
  <Edit {...props}>
    <Form {...props} />
  </Edit>
));

export const WebsitePagesCreate = t((props) => (
  <Create {...props}>
    <Form {...props} />
  </Create>
));
